import React, { useState, useEffect } from "react";
import { Loader } from "semantic-ui-react";
import { connect } from "react-redux";
import { getShoppingHistory } from "../../../../redux/actions/shoppingHistory";

import HistoryItem from "./components/HistoryItem/HistoryItem";
import ModalItemHistory from "./components/ModalHistoryItem/ModalItemHistory";

import "./styles.css";

const AccountHistory = ({ auth, getShoppingHistory, shoppingHistory }) => {
  const [state, setState] = useState({ modal: false, index: 0 });

  useEffect(() => {
    if (!auth.loading) {
      getShoppingHistory(auth.profile.email);
    }
  }, [auth, getShoppingHistory]);

  const toggle = (index) => {
    setState((prevState) => ({
      ...prevState,
      modal: !state.modal,
      index,
    }));
  };
  return (
    <>
      <div style={{ backgroundColor: "white" }}>
        {shoppingHistory.loading ? (
          <div className="account-history-loader-container">
            <Loader active inline="centered" />
          </div>
        ) : (
          <div className="account-history-container">
            <div className="account-history-overflowLimit">
              {shoppingHistory.data.length > 0 ? (
                shoppingHistory.data.map((item, index) => (
                  <HistoryItem
                    key={index}
                    index={index}
                    toggle={toggle}
                    item={item}
                    openModal={state.modal}
                  />
                ))
              ) : (
                <div className="account-history-no-shippings">
                  <h4>Todavía no ha realizado ninguna compra.</h4>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
      {/* ------------------- Desde aqui empieza la modal ------------------------- */}
      <ModalItemHistory
        openModal={state.modal}
        event={toggle}
        item={shoppingHistory.data[state.index]}
      />
    </>
  );
};
const mapStateToProps = ({ shoppingHistory }) => {
  return { shoppingHistory };
};

export default connect(mapStateToProps, { getShoppingHistory })(AccountHistory);
